import { render, staticRenderFns } from "./SoftwareInformation.vue?vue&type=template&id=2a0f23c0&scoped=true&"
import script from "./SoftwareInformation.vue?vue&type=script&lang=js&"
export * from "./SoftwareInformation.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareInformation.vue?vue&type=style&index=0&id=2a0f23c0&scoped=true&lang=css&"
import style1 from "./SoftwareInformation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f23c0",
  null
  
)

export default component.exports